export const sessionConstant = {
  SESSION_JOIN_DATA: 'session_joining_data',
  SESSION_DATE_FORMAT: 'YYYY-MM-DD HH:mm:ss'
};
